// @flow
import React from "react";
import type {GenericModalDispatchProps, GenericModalStateProps} from "../../../components/GenericModal";
import GenericModal from "../../../components/GenericModal";
import type {StoreState} from "../../../reducers/combinedReducers";
import * as _ from "lodash";
import {Dispatch} from "redux";
import {closeDeleteEBadgePhotoModalAction, photoEBadgeDeleteAction} from "../../../actions/ebadge/photo/creators/photoEBadgeActionCreator";
import {connect} from "react-redux";
import {extractCaller} from "../../QueryPage";

function mapStateToProps(state: StoreState): GenericModalStateProps {

    const isLoading = state.modal.deletePhoto.registrationCode
        ? _.get(state, `photoEBadgeAction.del.${state.modal.deletePhoto.registrationCode}.isLoading`, false)
        : false;

    const error = state.modal.deletePhoto.registrationCode
        ? _.get(state, `photoEBadgeAction.del.error`)
        : undefined;

    return {
        promptMsg: `Confirm to delete selected photo(s)?`,
        loadingMsg: `OK. We are deleting the photo(s).`,
        open: state.modal.deletePhoto.open,
        isLoading,
        error,
        primaryActionText: `Delete`,
        args: {
            registrationCode: state.modal.deletePhoto.registrationCode,
            caller: extractCaller(state)
        },
        primaryActionColor: 'danger'
    }
}

function mapDispatchToProps(dispatch: Dispatch): GenericModalDispatchProps {

    return {
        primaryAction: (args: any) => {
            dispatch(photoEBadgeDeleteAction(args.registrationCode, args.caller));
        },
        closeModal: () => {
            dispatch(closeDeleteEBadgePhotoModalAction())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GenericModal);


// WEBPACK FOOTER //
// ./src/containers/ebadge/photo/DeleteEBadgePhotoModal.js